export enum GermplasmListColumnCategory {
    STATIC = 'STATIC',
    NAMES = 'NAMES',
    VARIABLE = 'VARIABLE'
}
